import { AxiosResponse } from 'axios';
import { SignalApiUrls } from '../../../urls';
import {
  TestingWebhook,
  Webhook,
  WebhookStatus,
} from '../components/Webhook/types';
import { HttpClient } from '../../../HttpClient';
import { TroubleshootingWorkflow } from '../components/IssueResolution/types';

export default class ConfigurationClient extends HttpClient {
  async fetchWebhooks(
    partnerId: string,
  ): Promise<AxiosResponse<WebhookStatus[]>> {
    const response = await this.get<AxiosResponse<WebhookStatus[]>>(
      SignalApiUrls.getPostWebhooksUrl(partnerId),
    );
    return response;
  }

  async addWebhook(
    partnerId: string,
    webhook: Webhook,
  ): Promise<AxiosResponse<Webhook>> {
    const response = await this.post<AxiosResponse<Webhook>>(
      SignalApiUrls.getPostWebhooksUrl(partnerId),
      webhook,
    );
    return response;
  }

  async patchWebhook(
    partnerId: string,
    webhookid: string,
    webhook: Partial<Webhook>,
  ): Promise<AxiosResponse<Webhook>> {
    const response = await this.patch<AxiosResponse<Webhook>>(
      SignalApiUrls.getPatchWebhookUrl(partnerId, webhookid),
      webhook,
    );
    return response;
  }

  async deleteWebhook(
    partnerId: string,
    webhookid: string,
  ): Promise<AxiosResponse<Webhook>> {
    const response = await this.delete<AxiosResponse<Webhook>>(
      SignalApiUrls.getPatchWebhookUrl(partnerId, webhookid),
    );
    return response;
  }

  async testWebhook(
    partnerId: string,
    webhook: TestingWebhook,
  ): Promise<AxiosResponse<WebhookStatus>> {
    const response = await this.post<AxiosResponse<WebhookStatus>>(
      SignalApiUrls.getTestWebhooksUrl(partnerId),
      webhook,
    );
    return response;
  }

  async fetchTroubleshootingWorkflows(
    partnerId: string,
  ): Promise<AxiosResponse<any>> {
    const response = await this.get<AxiosResponse<TroubleshootingWorkflow[]>>(
      SignalApiUrls.getTroubleshootingWorkflows(partnerId),
    );
    return response;
  }

  async updateTroubleshootingWorkflowStatus(
    partnerId: string,
    workflowId: string,
    enabled: boolean,
  ): Promise<AxiosResponse<void>> {
    const response = await this.put<AxiosResponse<void>>(
      SignalApiUrls.getPatchTroubleshootingWorkflow(partnerId, workflowId),
      {
        enabled,
      },
    );
    return response;
  }

  async getEmailLanguages(
    partnerId: string,
  ): Promise<AxiosResponse<{ code: string; name: string; icon: string }[]>> {
    const response = await this.get<AxiosResponse<any>>(
      SignalApiUrls.getEmailLanguages(partnerId),
    );
    return response;
  }
}
